/**
 * 전화번호 포맷팅 유틸리티
 * - 저장: 하이픈 없이 숫자만 (01012345678)
 * - 표시: 하이픈 포맷팅 (010-1234-5678)
 */

/**
 * 숫자만 있는 전화번호를 표시용 하이픈 포맷으로 변환
 * "01012345678" -> "010-1234-5678"
 * "0212345678"  -> "02-1234-5678"
 */
export function formatPhoneDisplay(raw: string): string {
  const digits = raw.replace(/\D/g, '');

  if (digits.length <= 3) {
    return digits;
  }

  // 02 지역번호 (2자리)
  if (digits.startsWith('02')) {
    if (digits.length <= 6) {
      return `${digits.slice(0, 2)}-${digits.slice(2)}`;
    }
    if (digits.length <= 10) {
      return `${digits.slice(0, 2)}-${digits.slice(2, digits.length - 4)}-${digits.slice(digits.length - 4)}`;
    }
    return `${digits.slice(0, 2)}-${digits.slice(2, 6)}-${digits.slice(6, 10)}`;
  }

  // 010, 011, 031 등 3자리 앞번호
  if (digits.length <= 7) {
    return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  }

  if (digits.length <= 11) {
    return `${digits.slice(0, 3)}-${digits.slice(3, digits.length - 4)}-${digits.slice(digits.length - 4)}`;
  }

  // 11자리 초과 시 잘라냄
  return `${digits.slice(0, 3)}-${digits.slice(3, 7)}-${digits.slice(7, 11)}`;
}

/**
 * 하이픈 및 비숫자 문자 제거
 * "010-1234-5678" -> "01012345678"
 */
export function stripPhone(raw: string): string {
  return raw.replace(/\D/g, '');
}

/**
 * 유효한 전화번호인지 검증 (10~11자리 숫자)
 */
export function isValidPhone(phone: string): boolean {
  const digits = phone.replace(/\D/g, '');
  return /^\d{10,11}$/.test(digits);
}
